<template>
  <div class="container-fluid mt-2">
    <h2>Data Mapping</h2>
    <div class="btn-toolbar mt-3 mb-2">
      <div class="btn-group">
        <router-link to="/datamap/sources" class="btn btn-secondary">Datenquellen</router-link>
        <router-link to="/datamap/tables" class="btn btn-secondary">Datentabellen</router-link>
      </div>
    </div>
    <br/>
    <h4>Warenwirtschaftstabellen</h4>
    <b-tabs content-class="mt-3">
      <b-tab title="Artikel">
        <div class="row mt-3">
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article')">Stammdaten</a></h5>
                <p>
                  Basisdaten der Artikel wie Artikelnummer oder interne ID. <br/>Für Spezialfelder: <a target="_blank" href="/trendshop.proxy.web/help/datamap/index.html#special">Dokumentation</a>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_desc')">Texte</a></h5>
                <p>
                  Artikelbeschreibungen und Namen für alle Sprachen. Und die Kategoriebeschreibungen für alle Sprachen.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_img')">Bilder</a></h5>
                <p>
                  Produkt- und Kategoriebilder
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_cat')">Kategorien</a></h5>
                <p>
                  Kategoriebaum für das Artikelsortiment.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_category_links')">Kategorieverknüpfung</a></h5>
                <p>
                  Zuordnungsdaten von Artikel zu den unterschiedlichen Kategorien.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_partlist')">Stücklisten</a></h5>
                <p>
                  Stücklisten für Artikelvarianten und Displays.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_fieldinfo')">Zusatzfeld Infos</a></h5>
                <p>
                  Erweiterte Informationen zu Zusatzfeldern. Z.B. für die Sortierung oder Mehrsprachigkeit.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_info')">Artikel Zusatzinfos</a></h5>
                <p>
                  Allgemeine Verknüpfungen oder Anmerkungen zu den Produkten. Z.B. Link zu einem Produktdatenblatt etc.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_quantity_descs')">Mengenbeschreibungen</a></h5>
                <p>
                  Beschreibung für die Verpackungseinheiten.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('warehouse')">Lagerbestand</a></h5>
                <p>
                  Aktueller Lagerbestand und zusätzliche Infos.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_selections')">Sortimente</a></h5>
                <p>
                  Einträge aller vorhandenen Sortimente (keine Artikelzuordnung)
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_article_selection_link')">Sortiment-Zuordnung</a></h5>
                <p>
                  Zuordnung der Artikel und Kategorien zu den vorhandenen Sortimenten.
                </p>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Kunden">
        <div class="row mt-3">
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_customer')">Stammdaten</a></h5>
                <p>
                  Kundendaten mit den wichtigsten Stammdaten (Konditionsgruppe / Preislitse / Adresse...)
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('shop_address')">Adressdaten</a></h5>
                <p>
                  Liefer- und Rechnungsadresse oder Ansprechpartner
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('web_customer_selections')">Sortiment-Zuordnung</a></h5>
                <p>
                  Zuordnung der Kunden zu den vorhandenen Artikel-Sortimenten.
                </p>
              </div>
            </div>
          </div>
        <div class="col-md">
          <div class="card" style="width: 18rem;">
            <div class="card-body">
              <h5 class="card-title"><a href="#" @click="open('web_customer_extra_info')">Kunden Zusatzinfos</a></h5>
              <p>
                Zusatzinformationen zu den Kundeneinträgen. Resourcen URL oder Text-Content möglich.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md">
          <div class="card" style="width: 18rem;">
            <div class="card-body">
              <h5 class="card-title"><a href="#" @click="open('web_customer_groups')">Kunden-Gruppen</a></h5>
              <p>
                Einteilung der Kundenliste in unterschiedliche Gruppen / Bereiche.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="card" style="width: 18rem;">
            <div class="card-body">
              <h5 class="card-title"><a href="#" @click="open('costcentre')">Kostenstellen</a></h5>
              <p>
                Vorgegebene Kostenstellen für die Kunden zur Budgetverwaltung. Optional ist auch ein verwalten der Kostenstellen vom Kunden/Vertreter selbst möglich. Dann ist kein Mapping nötig.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="card" style="width: 18rem;">
            <div class="card-body">
              <h5 class="card-title"><a href="#" @click="open('costcentre2user')">Kostenstellenzuordnung</a></h5>
              <p>
                Vorgegebene Kostenstellenzuordnung (Kostenstelle -> Kontakt / Kunde) zur Budgetverwaltung. Optional ist auch ein verwalten der Kostenstellenzuordnung vom Kunden/Vertreter selbst möglich. Dann ist kein Mapping nötig.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md">
          <div class="card" style="width: 18rem;">
            <div class="card-body">
              <h5 class="card-title"><a href="#" @click="open('budgetrules')">Budgets</a></h5>
              <p>
                Vorgegebene Budget-Regeln für die Kunden und Besteller. Optional sind auch Budget-Regeln die der Kunde oder ein PowerUser / Vertreter seinen Bestellern vorgibt.
              </p>
            </div>
          </div>
        </div>
      </div>
      </b-tab>
      <b-tab title="Preise">
        <div class="row mt-3">
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('price_lists')">Preislisten</a></h5>
                <p>
                  Preislisteneinträge für alle Artikel.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('price_conditions')">Konditionsgruppen</a></h5>
                <p>
                  Konditionsgruppen für die Kunden.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('quantity_scale_lists')">Mengenstaffeln</a></h5>
                <p>
                  Mengenstaffeln für Preisrabatte
                </p>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab title="Aufträge">
        <div class="row mt-3">
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('shop_order_data')">Aufträge</a></h5>
                <p>
                  Auftragsdaten
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('delivery_note')">Lieferscheine</a></h5>
                <p>
                  Lieferscheindaten
                </p>
              </div>
            </div>
          </div>
          <div class="col-md">
              <div class="card" style="width: 18rem;">
                <div class="card-body">
                  <h5 class="card-title"><a href="#" @click="open('supplier_reorders')">Artikel Nachliefertermine</a></h5>
                  <p>
                    Artikel Nachliefertermine
                  </p>
                </div>
              </div>
            </div>
        </div>
      </b-tab>
      <b-tab title="Sonstiges">
        <div class="row mt-3">
          <div class="col-md">
            <div class="card" style="width: 18rem;">
              <div class="card-body">
                <h5 class="card-title"><a href="#" @click="open('shop_global_config')">Konfiguration</a></h5>
                <p>
                  Defaultwerte für Sprache / Währung etc.
                </p>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: 'DataMapOverview',
  methods: {
    open(name) {
      console.log(name);
      router.push({name:'DataTableEditor',params:{ name:name,sys:true }})
    }
  }
}
</script>
